import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DefaultMainPage} from 'src/globalTypes';
import {DefaultMainPageService} from 'app/core/services/default-main-page.service';
import {FormService} from 'app/core/services/form.service';
import {AppUrls, path} from 'app/core/url/app-urls.service';

@Component({
    selector: 'default-main-page',
    templateUrl: './default-main-page.component.html',
    styleUrls: ['./default-main-page.component.scss'],
    providers: [FormService],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultMainPageComponent implements OnInit {
    form: FormGroup;
    DefaultMainPage = DefaultMainPage;

    constructor(
        public formService: FormService,
        private fb: FormBuilder,
        protected mainPageService: DefaultMainPageService
    ) {}

    ngOnInit(): void {
        this.form = this.fb.group({
            isDefaultMainPage: ['', Validators.required],
        });
        this.formService.init(this.form);
    }

    selectDefaultPage(event: Event) {
        event.preventDefault();
        const page = this.form.get('isDefaultMainPage').value as DefaultMainPage;
        this.formService.submit(this.mainPageService.updateDefaultMainPage(page)).subscribe(
            () => {
                console.debug(page, 'main page is selected!');
                this.navigateToSelectedPage(page);
                this.form.reset();
            },
            err => {
                console.error(err, 'failed select page!');
            }
        );
    }

    navigateToSelectedPage(page: DefaultMainPage) {
        switch (page) {
            case DefaultMainPage.REPORTS:
                document.location.href = path(AppUrls.ANALYTICS_REPORTS);
                return;
            case DefaultMainPage.OVERVIEW:
                document.location.href = path(AppUrls.BUSINESS_OVERVIEW);
                return;
            default:
                document.location.href = path(AppUrls.MONETIZATION);
                return;
        }
    }
}
